/** Countdown until session ends (shown in seconds in the warning modal). */
export function formatRemainingSeconds(remainingMs: number): string {
  const seconds = Math.max(0, Math.ceil(remainingMs / 1000));
  return `${seconds} second${seconds === 1 ? "" : "s"}`;
}
